import { render, staticRenderFns } from "./Model15.vue?vue&type=template&id=36f98158&scoped=true&"
import script from "./Model15.vue?vue&type=script&lang=js&"
export * from "./Model15.vue?vue&type=script&lang=js&"
import style0 from "./Model15.vue?vue&type=style&index=0&id=36f98158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f98158",
  null
  
)

export default component.exports